module.exports = __webpack_public_path__ + "img/icon5.9bea93a5.png";